import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 4 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4 8.798c0 1.08-.895 1.955-2 1.955s-2-.875-2-1.955.895-1.955 2-1.955 2 .875 2 1.955m0-6.843c0 1.08-.895 1.955-2 1.955s-2-.875-2-1.955S.895 0 2 0s2 .875 2 1.955m0 13.686c0 1.08-.895 1.955-2 1.955s-2-.875-2-1.955.895-1.955 2-1.955 2 .875 2 1.955"
    }, null, -1)
  ]))]))
}
export default { render: render }